import React from "react";
import "./App.css";
import {Outlet} from "react-router-dom";
import {addLocale, locale} from "primereact/api";
import de from "./resources/de.json";

function App() {
  addLocale("de", de.de);
  locale("de");

  return (
    <div className="app">
      <main id="main" className="app__main">
        <div className="app__content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default App;
